import * as React from "react";
const SvgFiRrCircleStar = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#fi-rr-circle-star_svg__a)">
      <path
        fill="#062147"
        d="M9.02 17.35c-.19 0-.39-.06-.55-.18a.91.91 0 0 1-.32-1.01l.86-2.76-2.18-1.77a.92.92 0 0 1-.27-1.01c.13-.36.48-.6.86-.6h2.75l.97-2.61c.13-.36.48-.6.86-.6s.73.24.86.6l.97 2.61h2.75c.38 0 .73.24.86.6s.02.77-.27 1.02L15 13.41l.9 2.73c.12.37 0 .78-.31 1.01-.31.24-.73.25-1.06.04l-2.52-1.64-2.48 1.66c-.15.1-.33.15-.51.15zM12 24C5.38 24 0 18.62 0 12S5.38 0 12 0s12 5.38 12 12-5.38 12-12 12m0-22C6.49 2 2 6.49 2 12s4.49 10 10 10 10-4.49 10-10S17.51 2 12 2"
      />
    </g>
    <defs>
      <clipPath id="fi-rr-circle-star_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgFiRrCircleStar;
